import React from 'react';
import { Link } from 'react-router-dom';

import './Button.css';

const Button = (props) => {
  const nullClick = (e) => {
    e.preventDefault();
  };
  if (props.href) {
    return (
      <a
        className={`button button--${props.size || 'default'} ${props.inverse && 'button--inverse'} 

        ${props.inverseBlack && 'button--inverseBlack'}
        ${props.inverseBlue && 'button--inverseBlue'}
        ${props.danger && 'button--danger'} ${props.blackText && 'button--blackText'}
        ${props.blackText__border && 'button--blackText__border'}
        ${props.inverseBlack && 'button--inverseBlack'}
        `}
        href={props.href}
        style={props.style}
      >
        {props.children}
      </a>
    );
  }
  if (props.to) {
    return (
      <Link
        to={props.to}
        exact={props.exact}
        className={`button button--${props.size || 'default'} ${props.inverse ? 'button--inverse' : ''} ${
          props.danger && 'button--danger'
        } ${props.blackText ? 'button--blackText' : ''}
        ${props.blackText__border ? 'button--blackText__border' : ''} ${
          props.inverseBlack ? 'button--inverseBlack' : ''
        } ${props.inverseBlue ? 'button--inverseBlue' : ''}
        ${props.className}`}
        style={props.style}
      >
        {props.children}
      </Link>
    );
  }
  return (
    <button
      className={`button button--${props.size || 'default'} ${props.inverse ? 'button--inverse' : ''} ${
        props.danger ? 'button--danger' : ''
      } ${props.blackText ? 'button--blackText' : ''}
        ${props.blackText__border ? 'button--blackText__border' : ''}
        ${props.inverseBlack ? 'button--inverseBlack' : ''}
        ${props.inverseBlue ? 'button--inverseBlue' : ''}
        ${props.className}
      `}
      type={props.type}
      onClick={props.disabled ? nullClick : props.onClick}
      style={props.style}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
};

export default Button;
